import styled from 'styled-components'
import { animated } from '@react-spring/web'
import { Colors } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import Media from 'builder/styles/media'

interface PercentProps {
  points: number
}

export const Container = styled.div<{ isPageScrolled: boolean }>`
  display: block;
  user-select: none;
  position: sticky;
  top: 0px;
  background-color: ${Colors.White};
  z-index: ${props => (props.isPageScrolled ? 4 : 2)};

  padding-top: 12px;

  ${Media.Phone`
    &:before,
    &:after {
      width: 20px;
    }
  `};

  &:before {
    right: 100%;
  }

  &:after {
    left: 100%;
  }
`

export const Header = styled.div`
  display: flex;
  flex-flow: row nowrap;
  position: relative;
  max-width: 100%;
  overflow: hidden;
`

export const HeaderMain = styled.div`
  margin-right: 8px;
  margin-bottom: 8px;
  display: flex;
  flex: 0 1 auto;
  overflow: hidden;
`

export const HeaderText = styled.p`
  ${Typography.Caption};
  color: ${Colors.Neutral50};
  margin-right: 5px;
  display: block;
  max-width: 180px;
  height: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const HeaderAside = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 8px;
  gap: 8px;
`

export const Percent = styled(animated.div)<PercentProps>`
  display: inline-block;
  ${Typography.Tiny};
  ${FontWeights.DemiBold}
  border-radius: 4px;
  margin-right: 8px;
  color: ${Colors.White};
  font-variant-numeric: tabular-nums;
  width: fit-content;
  height: 20px;
  padding: 2px 4.5px;
  ${({ points }) => {
    switch (true) {
      case points > 70:
        return `
          background-color: ${Colors.Green40};
        `
      case points > 30:
        return `
          background-color: ${Colors.Amber40};
        `
      default:
        return `
          background-color: ${Colors.Red40};
        `
    }
  }}

  &:after {
    content: '%';
  }
`

export const Progress = styled.div`
  height: 3px;
  background-color: ${Colors.Neutral10};
`

export const ProgressInner = styled(animated.div)`
  height: 3px;
  width: 100%;
  transform-origin: left;
`
